import React, { useEffect, useState, useMemo } from "react";
// import { useEffect } from "react";
// import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Divider, Empty, message, Select, Spin } from "antd";

import CommonDivWidget from "components/CommonDivWidget/CommonDivWidget";
import "./RegistrationPage.css";
import ClubBoxWidget from "components/ClubBoxWidget/ClubBoxWidget";
import {
  apiDeleteRegInfo,
  apiGetRegGroupData,
  apiGetRegistrationDetail,
  apiGetRegistrationDetailByGroup,
  apiGetRegistrationDetailByLabel,
  apiGetRegistrationList,
  apiUpdateCampRegInfo,
  apiUpdateRegInfo,
  apiGetColumnPreferences,
  apiSaveColumnPreferences,
} from "services/dashboardService";
import { getDefaultColumnPreferences } from "./RegFormTable/columnConfig";
import ColumnPickerModal from "./ColumnPickerModal/ColumnPickerModal";
import RegFormTable from "./RegFormTable/RegFormTable";
import SearchWidget from "./SearchWidget/SearchWidget";
import GroupTable from "./GroupTable/GroupTable";
import RightDetailWidget from "./RightDetailWidget/RightDetailWidget";
import CampRightDetailWidget from "./RightDetailWidget/CampRightDetailWidget";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ROUTE_REGISTRATION_DETAIL } from "navigation/CONSTANTS";
const RegistrationPage = (props) => {
  const userDataStore = useSelector((x) => x.userDataStore);
  const appDataStore = useSelector((x) => x.appDataStore);
  const history = useHistory()
  const [isBusy, setIsBusy] = useState(false);
  const [userList, setUserList] = useState([]);
  const [srcList, setSrcList] = useState([]);
  const [tripList, setTripList] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [srcGroupList, setSrcGroupList] = useState([]);
  const [groupVal, setGroupVal] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [isGroup, setIsGroup] = useState(false);
  const [currentReport, setCurrentReport] = useState("home");
  const [visible, setVisible] = useState(false);
  const [userData, setUserData] = useState({});
  const [groupLabel, setGroupLabel] = useState("");
  const [telePhone, setTelephone] = useState("");
  const [cellPhone, setCellphone] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [regGroupList, setRegGroupList] = useState([]);
  const [columnPreferences, setColumnPreferences] = useState(null);
  const [showColumnPicker, setShowColumnPicker] = useState(false);
  const [isSavingPreferences, setIsSavingPreferences] = useState(false);
  useEffect(() => {
    if (appDataStore.curRegistration != undefined) {
      getRegGroupData();
      getRegistrationDetail();
      loadColumnPreferences();
    } else {
      setUserList([]);
      setSrcList([]);
    }
    console.log("userDataStore:", userDataStore); // ADDED: Inspect userDataStore
  }, [appDataStore.curRegistration]);

  const loadColumnPreferences = () => {
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("sport_type", userDataStore?.sport_type);

    apiGetColumnPreferences(params)
      .then((res) => {
        if (res && res.preferences) {
          setColumnPreferences(res.preferences);
        } else {
          // Use defaults if no preferences saved
          const defaults = getDefaultColumnPreferences(userDataStore?.sport_type);
          setColumnPreferences(defaults);
        }
      })
      .catch((err) => {
        console.error("Failed to load column preferences:", err);
        // Use defaults on error
        const defaults = getDefaultColumnPreferences(userDataStore?.sport_type);
        setColumnPreferences(defaults);
      });
  };

  const handleSaveColumnPreferences = (preferences) => {
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("sport_type", userDataStore?.sport_type);
    params.append("preferences", JSON.stringify(preferences));

    setIsSavingPreferences(true);

    apiSaveColumnPreferences(params)
      .then((res) => {
        setIsSavingPreferences(false);
        if (res) {
          message.success("Column preferences saved successfully");
          setColumnPreferences(preferences);
          setShowColumnPicker(false);
        }
      })
      .catch((err) => {
        setIsSavingPreferences(false);
        message.error("Failed to save column preferences: " + err);
      });
  };

  useEffect(() => {
    if (appDataStore.curRegistration == undefined) {
      setGroupVal("");
      return;
    }
    if (groupVal != "") {
      setIsGroup(true);
      getRegistrationByGroupDetail(groupVal);
      let label = "";
      if (groupVal == "fee_label") {
        label = "Registration Group";
      } else if (groupVal == "timestamp") {
        label = "Reg Date";
      } else if (groupVal == "gender") {
        label = "Gender";
      } else if (groupVal == "discount_code") {
        label = "Discount Code";
      } else if (groupVal == "payment_method") {
        label = "Payment method";
      }
      setGroupLabel(label);
    } else {
      setGroupLabel("");
    }
  }, [groupVal]);

  const onClear = () => {
    setSearchKey("");
    setGroupVal("");
    setIsGroup(false);
    getRegistrationDetail();
  };

  const onTransactionDetail = () => {
    history.push(ROUTE_REGISTRATION_DETAIL)
  }

  const onReportChange = (reportValue) => {
    setCurrentReport(reportValue);
    setSearchKey("");

    if (reportValue === "home") {
      // Show default view with configurable columns
      setIsGroup(false);
      setGroupVal("");
      getRegistrationDetail();
    } else if (reportValue === "registration_detail") {
      // Navigate to Registration Detail page
      history.push(ROUTE_REGISTRATION_DETAIL);
    } else if (reportValue === "discount_code") {
      // Group by Discount Code
      setGroupVal("discount_code");
    } else if (reportValue === "reg_date") {
      // Group by Registration Date
      setGroupVal("timestamp");
    } else if (reportValue === "programs") {
      // Group by Programs (camp only - fee_label)
      setGroupVal("fee_label");
    } else if (reportValue === "payment_method") {
      // Group by Payment Method
      setGroupVal("payment_method");
    }
  };

  const onSearch = (v) => {
    setSearchKey(v);
    let tmpList = [];
    if (isGroup) {
      tmpList = [...srcGroupList];
    } else {
      tmpList = [...srcList];
    }
    if (isGroup) {
      if (v == "") {
        setGroupList(tmpList);
      } else {
        setGroupList(
          tmpList.filter((x) => {
            if (x.fee_label.toLowerCase().includes(v.toLowerCase())) {
              return x;
            }
          })
        );
      }
    } else {
      if (v == "") {
        setUserList(tmpList);
      } else {
        if (userDataStore?.sport_type == "camp") {
          tmpList = tmpList.filter((x) => {
            if (x.name.toLowerCase().includes(v.toLowerCase())) {
              return x;
            }
          });
        } else {
          tmpList = tmpList.filter((x) => {
            if (
              x.p_email.toLowerCase().includes(v.toLowerCase()) ||
              x.name.toLowerCase().includes(v.toLowerCase())
            ) {
              return x;
            }
          });
        }
        setUserList(tmpList);
      }
    }
  };

  const getRegGroupData = () => {
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("sport_type", userDataStore?.sport_type);
    params.append("id", appDataStore.curRegistration.ID);
    console.log("Calling apiGetRegGroupData with params:", Object.fromEntries(params.entries()));
    apiGetRegGroupData(params)
      .then((res) => {
        if (res.length > 0) {
          setRegGroupList(res);
        } else {
          setRegGroupList([]);
        }
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  const getRegistrationDetail = () => {
    setUserList([]);
    setSrcList([]);
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("sport_type", userDataStore?.sport_type);
    params.append("registration_id", appDataStore.curRegistration.ID);
    setIsBusy(true);
    console.log("Calling apiGetRegistrationDetail with params:", Object.fromEntries(params.entries()));
    apiGetRegistrationDetail(params)
      .then((res) => {
        console.log("API Response Received:", res); // <-- ADDED: Log the raw response
        if (!res || !res.detail) {
          console.error("API response is invalid or missing 'detail' array.");
          setUserList([]);
          setSrcList([]);
          setIsBusy(false);
          message.error("Received invalid data from server.");
          return;
        }
        // Process the data to ensure immunization_verified is a boolean
        const processedData = res.detail.map(item => {
          // Use immun_verified if immunization_verified is not present
          const iv = item.immunization_verified !== undefined ? item.immunization_verified : item.immun_verified;
          const processed = {
            ...item,
            immunization_verified: iv === 1 || iv === true || iv === "1" || iv === "true"
          };
          return processed;
        });
        console.log(`Processing ${processedData.length} rows for the table.`); // <-- ADDED: Log the count
        setUserList(processedData);
        setSrcList(processedData);
        let tmpList = [...res.group_list];
        let tmpSrcList = tmpList.map((x, index) => {
          return {
            id: x.ID,
            title: x.registration_group_short_name,
            description: x.registration_group_name,
            price: x.registration_group_fee,
            checked: false,
            discount_available: x.discount_available,
          };
        });
        setTripList(tmpSrcList);
        setIsBusy(false);
      })
      .catch((err) => {
        console.error("Failed to fetch registration details:", err); // <-- ADDED: Better error logging
        setIsBusy(false);
        message.error(err);
      });
  };
  const getRegistrationByGroupDetail = (group) => {
    setGroupList([]);
    setSrcGroupList([]);
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("sport_type", userDataStore?.sport_type);
    params.append("id", appDataStore.curRegistration.ID);
    params.append("group", group);
    setIsBusy(true);
    console.log("Calling apiGetRegistrationDetailByGroup with params:", Object.fromEntries(params.entries()));
    apiGetRegistrationDetailByGroup(params)
      .then((res) => {
        setGroupList(res);
        setSrcGroupList(res);
        setIsBusy(false);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };
  const updateData = () => {
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("sport_type", userDataStore?.sport_type);
    params.append("id", userData.id);
    params.append("first_name", userData.first_name);
    params.append("last_name", userData.last_name);
    params.append("tele_phone", userData.tele_phone);
    params.append("birthday", userData.birthday);
    params.append("address", userData.address);
    params.append("city", userData.city);
    params.append("state", userData.state);
    params.append("gender", userData.gender);
    params.append("zip", userData.zip);
    params.append("grade", userData.grade);
    params.append("fee_label", userData.fee_label);
    params.append("p_first_name", userData.p_first_name);
    params.append("p_home_phone", userData.p_home_phone);
    params.append("p_last_name", userData.p_last_name);
    params.append("p_cell_phone", userData.p_cell_phone);
    params.append("p_relation", userData.p_relation);
    params.append("p_email", userData.p_email);
    params.append("c_first_name", userData.c_first_name);
    params.append("c_last_name", userData.c_last_name);
    params.append("c_email", userData.c_email);
    params.append("c_cell_phone", userData.c_cell_phone);
    console.log("Calling apiUpdateRegInfo with params:", Object.fromEntries(params.entries()));
    setIsBusy(true);
    apiUpdateRegInfo(params)
      .then((res) => {
        let selData = {
          ...userData,
          name: userData.first_name + " " + userData.last_name,
        };
        let tmpList = [...userList];
        let selId = tmpList.findIndex((x) => (x.id == userData.id));
        tmpList[selId] = selData;
        setUserList(tmpList);
        let tmpSrcList = [...srcList];
        let selsrcId = tmpSrcList.findIndex((x) => (x.id == userData.id));
        tmpSrcList[selsrcId] = selData;
        setSrcList(tmpSrcList);
        message.success("Updated successfully.");
        setIsBusy(false);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };
  const updateCampData = () => {
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("sport_type", userDataStore?.sport_type);
    params.append("id", userData.id);

    console.log('Updating camp data with userData:', userData);
    console.log('immun_verified value:', userData.immun_verified);

    params.append("camper_first_name", userData.camper_first_name);
    params.append("camper_last_name", userData.camper_last_name);
    params.append("camper_age", userData.camper_age);
    params.append("camper_grade", userData.camper_grade);
    params.append("camper_street", userData.camper_street);
    params.append("camper_city", userData.camper_city);
    params.append("camper_state", userData.camper_state);
    params.append("camper_zip", userData.camper_zip);
    params.append("camper_t_shirt", userData.camper_t_shirt);
    params.append("camper_health", userData.camper_health);
    params.append("camper_sel_trip", userData.camper_sel_trip);
    params.append("p_first_name", userData.p_first_name);
    params.append("p_last_name", userData.p_last_name);
    params.append("p_relation", userData.p_relation);
    params.append("p_email", userData.p_email);
    params.append("p_cell_phone", userData.p_cell_phone);
    params.append("p_home_phone", userData.p_home_phone);
    params.append("c_first_name", userData.c_first_name);
    params.append("c_last_name", userData.c_last_name);
    params.append("c_email", userData.c_email);
    params.append("c_cell_phone", userData.c_cell_phone);
    // Send immun_verified as well
    params.append("immun_verified", userData.immun_verified);
    
    console.log('Calling apiUpdateCampRegInfo with params:', Object.fromEntries(params.entries()));
    setIsBusy(true);
    apiUpdateCampRegInfo(params)
      .then((res) => {
        console.log('Update response:', res);
        let selData = {
          ...userData,
          name: userData.camper_first_name + " " + userData.camper_last_name,
          immunization_verified: userData.immunization_verified
        };
        let tmpList = [...userList];
        let selId = tmpList.findIndex((x) => (x.id == userData.id));
        tmpList[selId] = selData;
        setUserList(tmpList);
        let tmpSrcList = [...srcList];
        let selsrcId = tmpSrcList.findIndex((x) => (x.id == userData.id));
        tmpSrcList[selsrcId] = selData;
        setSrcList(tmpSrcList);
        message.success("Updated successfully.");
        setIsBusy(false);
      })
      .catch((err) => {
        console.error('Update error:', err);
        setIsBusy(false);
        message.error(err);
      });
  };
  const deleteData = (id) => {
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("sport_type", userDataStore?.sport_type);
    params.append("id", id);
    setIsBusy(true);
    console.log("Calling apiDeleteRegInfo with params:", Object.fromEntries(params.entries()));
    apiDeleteRegInfo(params)
      .then((res) => {
        let tmpList = [...userList];
        setUserList(tmpList.filter((x) => x.id != id));
        let tmpSrcList = [...srcList];
        setSrcList(tmpSrcList.filter((x) => x.id != id));
        message.success("Deleted successfully.");
        setIsBusy(false);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };
  const onDetail = (label) => {
    setUserList([]);
    setSrcList([]);
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("sport_type", userDataStore?.sport_type);
    params.append("registration_id", appDataStore.curRegistration.ID);
    params.append("label", label);
    params.append("type", groupVal);
    setIsBusy(true);
    console.log("Calling apiGetRegistrationDetailByLabel with params:", Object.fromEntries(params.entries()));
    apiGetRegistrationDetailByLabel(params)
      .then((res) => {
        if (res.detail != undefined) {
          setUserList(res.detail);
          setSrcList(res.detail);
        }
        setIsBusy(false);
        setIsGroup(false);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };
  const onVisible = (info) => {
    setVisible(true);
    setTelephone(info.tele_phone);
    setCellphone(info.p_cell_phone);
    setContactPhone(info.c_cell_phone);
    
    // Create a copy of info to modify
    let processedInfo = { ...info };
    
    // Ensure immunization_verified is properly initialized
    processedInfo.immunization_verified = processedInfo.immunization_verified === 1 || processedInfo.immunization_verified === true;
    
    setUserData({
      ...processedInfo,
      p_home_phone: processedInfo.p_home_phone || ""
    });
  };
  return (
    <CommonDivWidget>
      <Spin spinning={isBusy}>
        <div className="registration-page">
          <ClubBoxWidget />
          <div style={{ paddingLeft: 10, paddingRight: 10 }}>
            <Divider
              style={{ borderTop: "4px solid var(--mainColor)" }}
            ></Divider>
            <SearchWidget
              dataList={userList}
              groupList={groupList}
              isGroup={isGroup}
              onSearch={onSearch}
              searchKey={searchKey}
              setSearchKey={setSearchKey}
              sport_type={userDataStore?.sport_type}
              onColumnSettings={() => setShowColumnPicker(true)}
              currentReport={currentReport}
              onReportChange={onReportChange}
            />
            {useMemo(() => {
              if (isGroup) {
                return (
                  <GroupTable
                    dataList={groupList}
                    group={groupLabel}
                    onDetail={onDetail}
                    sport_type={userDataStore?.sport_type}
                  />
                );
              }
              return (
                <RegFormTable
                  dataList={userList}
                  setVisible={onVisible}
                  setUserData={setUserData}
                  deleteData={deleteData}
                  sport_type={userDataStore?.sport_type}
                  columnPreferences={columnPreferences}
                />
              );
            }, [
              isGroup,
              groupList,
              userList,
              groupLabel,
              userDataStore?.sport_type,
              columnPreferences,
            ])}
          </div>
          {userDataStore?.sport_type == "camp" ? (
            <CampRightDetailWidget
              visible={visible}
              setVisible={setVisible}
              userData={userData}
              setUserData={setUserData}
              updateData={updateCampData}
              telePhone={telePhone}
              setTelephone={setTelephone}
              cellPhone={cellPhone}
              setCellphone={setCellphone}
              contactPhone={contactPhone}
              setContactPhone={setContactPhone}
              regGroupList={regGroupList}
              tripList={tripList}
            />
          ) : (
            <RightDetailWidget
              visible={visible}
              setVisible={setVisible}
              userData={userData}
              setUserData={setUserData}
              updateData={updateData}
              telePhone={telePhone}
              setTelephone={setTelephone}
              cellPhone={cellPhone}
              setCellphone={setCellphone}
              contactPhone={contactPhone}
              setContactPhone={setContactPhone}
              regGroupList={regGroupList}
              tripList={tripList}
            />
          )}
        </div>
      </Spin>
      <ColumnPickerModal
        visible={showColumnPicker}
        onClose={() => setShowColumnPicker(false)}
        onSave={handleSaveColumnPreferences}
        sportType={userDataStore?.sport_type}
        currentPreferences={columnPreferences}
        isBusy={isSavingPreferences}
      />
    </CommonDivWidget>
  );
};



export default RegistrationPage;
